module.exports = __webpack_public_path__ + "static/media/login_bg_2_1920x1080.a8a11c7c.jpg";